// extracted by mini-css-extract-plugin
export default {"deviceActivityPageContainer":"DeviceActivityPage_deviceActivityPageContainer__eHq2I"};